import React from 'react';
import Fontawesome from '../../fontawesome/fontawesome';
import { Link } from 'react-router-dom';
import OsServices from './osServices';

const Options = ({ id, idContractItem }) => {
  return (
    <div className="dropdown">
      <Link
        to="#"
        className="dropdown link_color_datatable"
        id="dropdownNotification"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Fontawesome classe="fas fa-bars" />
      </Link>
      <ul
        className="dropdown-menu fade-in-top drop-options"
        aria-labelledby="dropdownNotification"
      >
        {/* <li>
          <OsAttachments id={id} />
        </li> */}
        <li>
          <OsServices id={id} idContractItem={idContractItem} />
        </li>
        {/* <li>
          <OsComments id={id} />
        </li> */}
      </ul>
    </div>
  );
};
export default Options;
